import { CommonMessages } from '../common.messages';

export const PanelSettingsAuditsMessages = {
  GetAuditsFailed: {
      key: 'GetAuditsFailed',
      message: 'Error while communication with the server. Cannot get available audit items.'
  },
  ...CommonMessages
};
